import { defineMessages } from 'react-intl';

export default defineMessages({
  location: {
    id: 'app.setup.register.location',
    description: 'Title category',
    defaultMessage: 'Location',
  },
  selectLocation: {
    id: 'app.setup.register.selectLocation',
    description: 'Dropdown placeholder prompt',
    defaultMessage: 'Select a location...',
  },
  nickname: {
    id: 'app.setup.register.nickname',
    description: 'Input field title',
    defaultMessage: 'Nickname',
  },
  optional: {
    id: 'app.setup.register.optional',
    description: 'Input field placeholder',
    defaultMessage: 'optional',
  },
  next: {
    id: 'app.setup.register.next',
    description: '\'Next\' button text',
    defaultMessage: 'Next',
  },
  managerWarning: {
    id: 'app.setup.register.managerWarning',
    description: 'Warning for managers',
    defaultMessage: 'Only staff in teams you manage will be able to clock in',
  },
});



// WEBPACK FOOTER //
// ./src/components/setup/register/i18n.js